import { Grid } from "@mui/material";
import { FC } from "react";
import Breadcrumb from "../../../components/breadcrumb/Breadcrumb";
import Containers from "../../../components/Containers";
import { H3 } from "../../../components/Typography";
import SortedTable from "../../../components/tables/SortedTable";
import BasicSortedTable from "../../../components/tables/BasicSortedTable";

const AdvanceSortedTable: FC = () => {
  const { TableContainer } = Containers();
  return (
    <>
      <Breadcrumb
        name="data-tables"
        subName="Sorted Table"
        path="/dashboard/v1"
      />

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TableContainer>
            <H3 pb="1rem">Basic Sorted Data Table</H3>
            <BasicSortedTable />
          </TableContainer>
        </Grid>
        <Grid item xs={12}>
          <TableContainer>
            <H3 pb="1rem">Advance Sorted Data Table</H3>
            <SortedTable />
          </TableContainer>
        </Grid>
      </Grid>
    </>
  );
};

export default AdvanceSortedTable;
